import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import LayoutRoute from '../components/LayoutRoute/components';

import { setNewAPI } from '../services';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  Login,
  Dashboard,
  NotificationsList,
  NotificationsConfig,
  InitialRegistration,
  PasswordRecovery,
  PasswordReset,
  Profile,
  CashFlow,
  Transactions,
  OperationalHistory,
  SessionsRegistration,
  ActivitiesRegistration,
  Services,
  EmployeesRegistration,
  EmployeesList,
  PriceTable,
  BusinessInfo,
  BusinessInfoRegistration,
  ClientList,
  ListClients,
  ClientInvoices,
  ClientRegistration,
  Accounts,
  Categories,
  CostCenters,
  PaymentMethods,
  ProvisionalReceipt,
  ProvisionalReceiptConfig,
  ProvisionalReceiptProductConfig,
  ProvisionalReceiptTypeSelection,
  PageNotFound,
  Receipt,
  Operation,
  Cashier,
  ComissionedList,
  ComissionedRegistration,
  ComissionedPayrolls,
  ComissionedPayrollList,
  ComissionedPayrollRegistration,
  ComissionedPayrollSheet,
  VehicleDamage,
  Products,
  ProductsConsume,
  ProductsSell,
  ProductsRegistration,
  ProductsSellRegistration,
  ProductsUseAndSellRegistration,
  ProductsTypeSelection,
  ProductsCategories,
  ProductsBrands,
  StorageHistory,
  SellOrders,
  SellOrderConsult,
  SupplierList,
  SupplierRegistrationPage,
  Scheduling,
  SchedulingConfigurations,
  VehicleTracking,
  AdvancedConfigurations,
  OpenAPI,
  OpenAPIRegistration,
  SelfService
} from '../pages';

import SchedulingServicesRegistration from '../components/SchedulingServicesRegistration/components';
import SchedulingOthersRegistration from '../components/SchedulingOthersRegistration/components';

setNewAPI();

const Routes = () => {
  const { isAdminUser } = useSelector(state => state.profile.submit);
  const isUserAdmin = +isAdminUser == 1;

  return (
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        style={{ zIndex: 1999 }}
      />
      <Switch>
        <Route
          exact
          path="/"
          component={Login}
        />
        <Route
          exact
          path="/termos-nota-fiscal"
          component={Login}
        />
        <Route
          exact
          path="/area-cliente"
          component={Login}
        />
        <Route
          exact
          path="/cadastro-cartao"
          component={Login}
        />
        <Route
          exact
          path="/esqueci-a-senha"
          component={PasswordRecovery}
        />
        <Route
          exact
          path="/resetar-senha/:token/:email"
          component={PasswordReset}
        />
        <Route
          path="/:resaleId?/cadastro-inicial"
          component={InitialRegistration}
        />
        <Route
          path="/acompanhamento-veiculos"
          component={VehicleTracking}
        />
        <Route
          path="/pedido/:orderId"
          component={SellOrderConsult}
        />
        <LayoutRoute
          showTimeRange
          singleEstablishment={isUserAdmin}
          path="/visao-geral"
          component={Dashboard}
        />
        <LayoutRoute
          hideEstablishments
          path="/perfil"
          name="Perfil"
          component={Profile}
        />
        <LayoutRoute
          singleEstablishment={isUserAdmin}
          path="/fluxo-de-caixa"
          name="Fluxo de Caixa"
          component={CashFlow}
        />
        <LayoutRoute
          singleEstablishment={isUserAdmin}
          showTimeRange
          enableSelectFutureDates
          path="/transacoes"
          name="Transações"
          component={Transactions}
        />
        <LayoutRoute
          singleEstablishment
          enableSelectFutureDates
          path="/lembrete-pos-venda"
          name="Lembrete Pós Venda"
          component={NotificationsList}
        />
        <LayoutRoute
          singleEstablishment
          path="/configuracao-de-lembrete"
          name="Configuração de Lembretes"
          component={NotificationsConfig}
        />
        <LayoutRoute
          singleEstablishment
          showDate
          name="Notas fiscais"
          path="/notas-fiscais"
          component={ProvisionalReceipt}
        />
        <LayoutRoute
          singleEstablishment
          path="/tipo-de-nota-fiscal"
          name="Seleção de tipo de nota fiscal"
          component={ProvisionalReceiptTypeSelection}
          previousPaths={[
            { name: 'Notas fiscais', path: '/notas-fiscais' }
          ]}
        />
        <LayoutRoute
          showTimeRange
          singleEstablishment={isUserAdmin}
          path="/historico-operacional"
          name="Histórico operacional"
          component={OperationalHistory}
        />
        <LayoutRoute
          singleEstablishment={isUserAdmin}
          path="/registro-de-sessoes"
          name="Registro de sessões"
          component={SessionsRegistration}
        />
        <LayoutRoute
          showDate
          singleEstablishment={isUserAdmin}
          path="/registro-de-atividades"
          name="Registro de atividades"
          component={ActivitiesRegistration}
        />
        <LayoutRoute
          singleEstablishment={isUserAdmin}
          path="/historico-de-avarias"
          name="Registro de avarias"
          component={VehicleDamage}
        />
        <LayoutRoute
          singleEstablishment
          path="/fornecedores"
          name="Fornecedores"
          component={SupplierList}
        />
        <LayoutRoute
          hideEstablishments
          showEstablishmentName
          path="/novo-fornecedor"
          name="Cadastrar Fornecedor"
          component={SupplierRegistrationPage}
          previousPaths={[
            { name: 'Fornecedores', path: '/fornecedores' }
          ]}
        />
        <LayoutRoute
          hideEstablishments
          showEstablishmentName
          path="/editar-fornecedor"
          name="Editar Fornecedor"
          component={SupplierRegistrationPage}
          previousPaths={[
            { name: 'Fornecedores', path: '/fornecedores' }
          ]}
        />
        <LayoutRoute
          singleEstablishment
          path="/agendamento"
          name="Agendamento"
          component={Scheduling}
        />
        <Route
          exact
          path="/configuracao-agendamento"
          component={SchedulingConfigurations}
        />
        <Route
          exact
          path="/novo-agendamento-servico"
          component={SchedulingServicesRegistration}
        />
        <Route
          exact
          path="/editar-agendamento-servico"
          component={SchedulingServicesRegistration}
        />
        <Route
          exact
          path="/novo-agendamento"
          component={SchedulingOthersRegistration}
        />
        <Route
          exact
          path="/editar-agendamento"
          component={SchedulingOthersRegistration}
        />
        <LayoutRoute
          singleEstablishment
          path="/produtos"
          name="Produtos"
          component={Products}
        />
        <LayoutRoute
          singleEstablishment
          path="/produtos-consumo"
          name="Produtos"
          component={ProductsConsume}
        />
        <LayoutRoute
          singleEstablishment
          path="/produtos-venda"
          name="Produtos"
          component={ProductsSell}
        />
        <LayoutRoute
          hideEstablishments
          path="/novo-produto"
          name="Cadastrar Produto para Consumo"
          component={ProductsRegistration}
          previousPaths={[
            { name: 'Produtos', path: '/produtos-consumo' }
          ]}
        />
        <LayoutRoute
          hideEstablishments
          path="/editar-produto"
          name="Editar Produto para Consumo"
          component={ProductsRegistration}
          previousPaths={[
            { name: 'Produtos', path: '/produtos-consumo' }
          ]}
        />
        <LayoutRoute
          hideEstablishments
          path="/novo-produto-venda"
          name="Cadastrar Produto para Venda"
          component={ProductsSellRegistration}
          previousPaths={[
            { name: 'Produtos', path: '/produtos-venda' }
          ]}
        />
        <LayoutRoute
          hideEstablishments
          path="/editar-produto-venda"
          name="Editar Produto para Venda"
          component={ProductsSellRegistration}
          previousPaths={[
            { name: 'Produtos', path: '/produtos-venda' }
          ]}
        />
        <LayoutRoute
          hideEstablishments
          path="/novo-produto-consumo-e-venda"
          name="Cadastrar Produto para Consumo e Venda"
          component={ProductsUseAndSellRegistration}
          previousPaths={[
            { name: 'Produtos', path: '/produtos' }
          ]}
        />
        <LayoutRoute
          hideEstablishments
          path="/editar-produto-consumo-e-venda"
          name="Editar Produto para Consumo e Venda"
          component={ProductsUseAndSellRegistration}
          previousPaths={[
            { name: 'Produtos', path: '/produtos' }
          ]}
        />
        <LayoutRoute
          hideEstablishments
          path="/objetivo-do-produto"
          name="Objetivo do Produto"
          component={ProductsTypeSelection}
          previousPaths={[
            { name: 'Produtos', path: '/produtos' }
          ]}
        />
        <LayoutRoute
          singleEstablishment
          path="/categorias-de-produtos"
          name="Categorias"
          component={ProductsCategories}
        />
        <LayoutRoute
          singleEstablishment
          path="/marcas-de-produtos"
          name="Marcas"
          component={ProductsBrands}
        />
        <LayoutRoute
          hideEstablishments
          path="/movimentacao-de-estoque"
          name="Movimentação de Estoque"
          component={StorageHistory}
        />
        <LayoutRoute
          singleEstablishment
          showTimeRange
          path="/historico-de-venda"
          name="Ordens de Pedido"
          component={SellOrders}
        />
        <LayoutRoute
          singleEstablishment
          name="Estabelecimento"
          path="/estabelecimento"
          component={BusinessInfo}
        />
        <LayoutRoute
          hideEstablishments
          name="Novo estabelecimento"
          path="/novo-estabelecimento"
          component={BusinessInfoRegistration}
        />
        <LayoutRoute
          singleEstablishment
          name="Tabelas de preço"
          path="/tabelas-de-preco"
          component={PriceTable}
        />
        <LayoutRoute
          singleEstablishment
          name="Serviços"
          path="/servicos"
          component={Services}
        />
        <LayoutRoute
          singleEstablishment
          name="Totens (Autoatendimento)"
          path="/autoatendimento"
          component={SelfService}
        />
        <LayoutRoute
          singleEstablishment={isUserAdmin}
          name="Usuários"
          path="/usuarios"
          component={EmployeesList}
        />
        <LayoutRoute
          hideEstablishments
          name="Cadastrar usuário"
          path="/novo-usuario"
          previousPaths={[
            { name: 'Lista de Usuários', path: '/usuarios' },
          ]}
          component={EmployeesRegistration}
        />
        <LayoutRoute
          hideEstablishments
          name="Editar usuário"
          path="/editar-usuario"
          previousPaths={[
            { name: 'Lista de usuários', path: '/usuarios' },
          ]}
          component={EmployeesRegistration}
        />
        <LayoutRoute
          singleEstablishment
          name="Funcionários"
          path="/funcionarios"
          component={ComissionedList}
        />
        <LayoutRoute
          hideEstablishments
          name="Novo funcionário"
          path="/novo-funcionario"
          previousPaths={[
            { name: 'Lista de Funcionários', path: '/funcionarios' }
          ]}
          component={ComissionedRegistration}
        />
        <LayoutRoute
          hideEstablishments
          name="Editar funcionário"
          path="/editar-funcionario"
          previousPaths={[
            { name: 'Lista de Funcionários', path: '/funcionarios' }
          ]}
          component={ComissionedRegistration}
        />
        <LayoutRoute
          singleEstablishment
          name="Comissionamento"
          path="/comissionamento"
          component={ComissionedPayrollList}
        />
        <LayoutRoute
          hideEstablishments
          showEstablishmentName
          name="Editar comissionado"
          path="/editar-comissionado"
          previousPaths={[
            { name: 'Comissionamento', path: '/comissionamento' }
          ]}
          component={ComissionedPayrollRegistration}
        />
        <LayoutRoute
          hideEstablishments
          showEstablishmentName
          name="Folhas de comissão"
          path="/folhas-de-comissao"
          previousPaths={[
            { name: 'Comissionamento', path: '/comissionamento' }
          ]}
          component={ComissionedPayrollSheet}
        />
        <LayoutRoute
          singleEstablishment={isUserAdmin}
          name="Clientes"
          path="/clientes"
          component={ClientList}
        />
        <LayoutRoute
          singleEstablishment={isUserAdmin}
          name="Suas Assinaturas"
          path="/suas-assinaturas"
          component={ListClients}
        />
        <LayoutRoute
          hideEstablishments
          showEstablishmentName
          name="Cadastro de cliente"
          path="/cadastro-de-cliente"
          previousPaths={[{ name: 'Lista de clientes', path: '/clientes' }]}
          component={ClientRegistration}
        />
        <LayoutRoute
          hideEstablishments
          showEstablishmentName
          name="Faturas"
          path="/faturas"
          previousPaths={[{ name: 'Lista de clientes', path: '/clientes' }]}
          component={ClientInvoices}
        />
        <LayoutRoute
          hideEstablishments
          showEstablishmentName
          name="Folhas de pagamento"
          path="/folhas-de-pagamento"
          previousPaths={[
            { name: 'Lista de Funcionários', path: '/funcionarios' }
          ]}
          component={ComissionedPayrolls}
        />
        <LayoutRoute
          singleEstablishment
          name="Comprovantes"
          path="/comprovantes"
          component={Receipt}
        />
        <LayoutRoute
          singleEstablishment
          name="Operação"
          path="/operacao"
          component={Operation}
        />
        <LayoutRoute
          singleEstablishment
          name="Caixa"
          path="/caixa"
          component={Cashier}
        />
        <LayoutRoute
          singleEstablishment
          name="Configurações Avançadas"
          path="/configuracoes-avancadas"
          component={AdvancedConfigurations}
        />
        <LayoutRoute
          hideEstablishments
          path="/api-aberta"
          name="API Aberta"
          component={OpenAPI}
        />
        <LayoutRoute
          hideEstablishments
          path="/nova-integracao-de-api"
          name="Nova integração de API"
          previousPaths={[
            { name: 'API Aberta', path: '/api-aberta' }
          ]}
          component={OpenAPIRegistration}
        />
        <LayoutRoute
          hideEstablishments
          path="/editar-integracao-de-api"
          name="Editar integração de API"
          previousPaths={[
            { name: 'API Aberta', path: '/api-aberta' }
          ]}
          component={OpenAPIRegistration}
        />
        <LayoutRoute
          singleEstablishment={isUserAdmin}
          name="Contas"
          path="/contas"
          component={Accounts}
        />
        <LayoutRoute
          singleEstablishment
          name="Meios de pagamento"
          path="/meios-de-pagamento"
          component={PaymentMethods}
        />
        <LayoutRoute
          singleEstablishment
          name="Categorias"
          path="/categorias"
          component={Categories}
        />
        <LayoutRoute
          singleEstablishment
          name="Centros de Custo"
          path="/centros-de-custo"
          component={CostCenters}
        />
        <LayoutRoute
          singleEstablishment
          name="Notas fiscais"
          path="/configuracoes-de-notas-fiscais"
          previousPaths={[
            { name: 'Lista de notas fiscais', path: '/notas-fiscais' }
          ]}
          component={ProvisionalReceiptConfig}
        />
        <LayoutRoute
          singleEstablishment
          name="Notas fiscais de produto"
          path="/configuracoes-de-notas-fiscais-de-produto"
          previousPaths={[
            { name: 'Lista de notas fiscais', path: '/notas-fiscais' }
          ]}
          component={ProvisionalReceiptProductConfig}
        />
        <LayoutRoute
          hideEstablishments
          path="*"
          name="Página não encontrada"
          component={PageNotFound}
        />
        <Redirect to="/pagina-nao-encontrada" />
      </Switch>
    </Router>
  );
}

export default Routes;